import { useEffect, useRef } from 'react';
import beemg_arrow from '../../Assets/icons/beemg-arrow.svg';

type SidebarModalProps = {
    title: string;
    items: { id: string; question: string }[];
    isOpen: boolean;
    onClose: () => void;
    onItemClick: any;
    position?: "left" | "right";
};

const SidebarModal: React.FC<SidebarModalProps> = ({
    title,
    items,
    isOpen,
    onClose,
    onItemClick,
    position = "right",
}) => {
    const modalRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <>
            {/* Overlay */}
            <div className="fixed inset-0 bg-black bg-opacity-50 z-[9998]" />

            {/* Modal */}
            <div
                ref={modalRef}
                className={`fixed top-0 ${position === "right" ? "right-0" : "left-0"} w-[30%] bg-white p-6 z-[9999] overflow-y-auto h-screen`}
            >
                {/* Space above title */}
                <div className="pt-16"></div>
                
                {/* Title section */}
                <div className="relative flex items-center pb-4 px-6">
                    <h2 className="text-md font-semibold">{title}</h2>
                </div>

                {items.length > 0 ? (
                    <ul>
                        {items.map((item) => (
                            <li
                                key={item.id}
                                className="flex flex-col" 
                                onClick={() => onItemClick(item)}
                            >
                                <div className="flex justify-between items-center py-1 px-6 mb-1 cursor-pointer rounded">
                                    <span className="text-gray-800 font-medium text-sm">{item.question}</span>
                                    <span className="text-gray-500 pl-2">
                                        <img src={beemg_arrow} alt="arrow" className="w-3 h-3" />
                                    </span>
                                </div>
                                {/* Horizontal divider that spans full width */}
                                <div className="border-b border-gray-500 mx-6"></div>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <div className="flex items-center justify-center h-[50vh]">
                        <p className="text-gray-500">No items found.</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default SidebarModal;